import { Component, Input, OnInit } from '@angular/core';
import { Blog } from '@sparro/app/core/models/blog.model';

@Component({
  selector: 'uni-blog-card-subtitle',
  templateUrl: './blog-card-subtitle.component.html',
  styleUrls: ['./blog-card-subtitle.component.scss']
})
export class BlogCardSubtitleComponent implements OnInit {
  @Input() blog: Blog;
  @Input() featured: boolean;
  @Input() cardWidth: number = null;

  constructor() { }

  ngOnInit() {
  }
}
